package com.appcreator.blueprint.core.properties

import kotlinx.serialization.Serializable

@Serializable
data class LocalizableString(
    val localizationEnabled: Boolean = true,
    val values: Map<String, String> = emptyMap()
)
